const initialState = () => {
  return {
    loginResult: 0,
    loginMessage: '',
    userData: null,
    serviceNo: null
  };
};

const state = initialState()

const actions = {
  CHANGE_STATE: ({ commit }, params) => {
    commit('MUTATION_CHANGE_STATE', params);
  },
  CHECK_LOGIN: ({ commit }, params) => {
    commit('MUTATION_CHECK_LOGIN', params);
  },
  POST_LOGIN: ({ commit }, params) => {
    commit('MUTATION_POST_LOGIN', params);
  },
  SET_INIT: ({ commit }, params) => {
    commit('MUTATION_SET_INIT', params);
  }
}

const mutations = {
  MUTATION_CHANGE_STATE: (state, payload) => {
    Object.keys(payload).map((key) => {
      state[key] = payload[key];
    })
    // state[payload.key] = payload.value;
  },
  MUTATION_POST_LOGIN: (state, payload) => {
    if (payload && payload.data) {
      const {
        sessionTimeout,
        loginResult,
        loginMessage,
        userData,
        serviceNo,
        originalServiceNo
      } = payload.data.list;

      state['sessionTimeout'] = sessionTimeout;
      state['loginResult'] = loginResult;
      state['loginMessage'] = loginMessage;
      state['userData'] = userData;
      state['serviceNo'] = serviceNo;
      state['originalServiceNo'] = originalServiceNo;
    } else {
      state['loginResult'] = 2;
      state['loginMessage'] = "Unable to connect to Server";
      state['userData'] = null;
      state['serviceNo'] = null;
    }
  },
  MUTATION_CHECK_LOGIN: (state, payload) => {
    if (payload && payload.data) {
      const { sessionTimeout, userData } = payload.data.list;

      state['sessionTimeout'] = sessionTimeout;
      state['userData'] = userData;
    }
  },
  MUTATION_SET_INIT: (state) => {
    Object.assign(state, initialState())
  }
}

const getters = {
  STATE: (state) => {
    return state
  }
  //
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}